import axios from '@/libs/api.request'

// 机构

// 机构列表
export const apiOrganizationList = (data) => {
    return axios.request({
        url: '/company',
        method: 'get',
        data
    })
}

// 机构添加
export const apiOrganizationAdd = (data) => {
    return axios.request({
        url: '/company',
        method: 'post',
        data
    })
}

// 机构删除
export const apiOrganizationDelete = (id) => {
    return axios.request({
        url: `/company/${id}`,
        method: 'delete',
    })
}

// 机构更新
export const apiOrganizationUpdate = (id,data) => {
    return axios.request({
        url: `/company/${id}`,
        method: 'put',
        data
    })
}
// 机构详情
export const apiOrganizationDetail = (id) => {
    return axios.request({
        url: `/company/${id}`,
        method: 'get',
    })
}

// 机构免登录
export const apiOrganizationNoAuth = (id,data) => {
    return axios.request({
        url: `/company-login/${id}`,
        method: 'get',
        data
    })
}

// 机构配置
export const apiGetSystem = (id,key,data) => {
    return axios.request({
        url: `/agency/setting/${id}/${key}`,
        method: 'get',
        data
    })
}

// 机构配置
export const apiSetSystem = (id,key,data) => {
    return axios.request({
        url: `/agency/setting/${id}/${key}`,
        method: 'put',
        data
    })
}

// 获取服务器地址
export const apiGetSystemServiceUrl = (id,data) => {
    return axios.request({
        url: `/agency/setting/${id}/wechat-service-url`,
        method:'get',
        data
    })
}
